// extracted by mini-css-extract-plugin
module.exports = {"container":"load-error_container__9e7XC","content":"load-error_content__z46sU","title":"load-error_title__lcIGY","description":"load-error_description__JKd6Y"};